<div class="workbench-video-viewer-container">
  @if (fetchFailed) {
    Couldn't fetch the video!
  } @else {
    @if (videoInProcessingState) {
      Video is currently being processed!
    } @else if (loadingVideoError) {
      Failed to load the video!
    } @else if (loadingVideo) {
      <p-progressSpinner></p-progressSpinner>
    }
    <video #videoPlayer controls preload="metadata"
       (canplay)="onVideoLoaded()"
       (error)="onVideoLoadError()"
       [class.hidden]="loadingVideo || loadingVideoError || videoInProcessingState"
    >
      @if (videoUrl) {
        <source [src]="videoUrl" [type]="videoFormat" (error)="onVideoLoadError()">
        The video player is not supported by your browser.
      } @else {
        Loading video ...
      }
    </video>
  }
</div>
